var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "发件人名称" },
            model: {
              value: _vm.searchData.nickName,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "nickName", $$v)
              },
              expression: "searchData.nickName"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.fetchList }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showAdd = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumn, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  formatter: item.formatter,
                  prop: item.prop
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.editItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAdd,
            width: "500px",
            title: _vm.configForm.id ? "编辑邮件发件人" : "新增邮件发件人",
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showAdd = $event
            },
            open: _vm.onAddDialogOpen,
            close: _vm.onAddDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "configForm",
              attrs: {
                rules: _vm.configFormRule,
                "validate-on-rule-change": false,
                "label-width": "120px",
                model: _vm.configForm
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "服务器地址",
                    required: "",
                    prop: "smtpServer"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写服务器地址", clearable: "" },
                    model: {
                      value: _vm.configForm.smtpServer,
                      callback: function($$v) {
                        _vm.$set(_vm.configForm, "smtpServer", $$v)
                      },
                      expression: "configForm.smtpServer"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "服务器端口", prop: "smtpPort" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      placeholder: "请填写服务器端口",
                      clearable: ""
                    },
                    model: {
                      value: _vm.configForm.smtpPort,
                      callback: function($$v) {
                        _vm.$set(_vm.configForm, "smtpPort", $$v)
                      },
                      expression: "configForm.smtpPort"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱账号", prop: "account" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写邮箱账号", clearable: "" },
                    model: {
                      value: _vm.configForm.account,
                      callback: function($$v) {
                        _vm.$set(_vm.configForm, "account", $$v)
                      },
                      expression: "configForm.account"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写密码", clearable: "" },
                    model: {
                      value: _vm.configForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.configForm, "password", $$v)
                      },
                      expression: "configForm.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发件人昵称", prop: "nickName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写发件人昵称", clearable: "" },
                    model: {
                      value: _vm.configForm.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.configForm, "nickName", $$v)
                      },
                      expression: "configForm.nickName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveConfig }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }